export default __webpack_public_path__ + "static/media/icon_proteins.d49a74ff.svg";